import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetFieldsWithSystemFieldEnumQueryVariables = Types.Exact<{
   params: Types.SearchFieldsParams
}>

export type GetFieldsWithSystemFieldEnumQuery = {
   __typename?: 'Query'
   searchFields:
      | { __typename?: 'InvalidLimit'; message?: string | null }
      | { __typename?: 'InvalidOffset'; message?: string | null }
      | { __typename?: 'PaginationLimitExceeded'; message?: string | null }
      | {
           __typename?: 'PipelineAccessDenied'
           message?: string | null
           pipelineId: string
           name: string
        }
      | {
           __typename?: 'PipelineNotFound'
           message?: string | null
           pipelineId: string
        }
      | {
           __typename?: 'SalesTemplateFieldsResult'
           totalCount: number
           salesTemplateFields: Array<{
              __typename?: 'SalesTemplateFields'
              salesTemplateId: string
              fields: Array<
                 | { __typename?: 'CheckboxGroupField' }
                 | { __typename?: 'DateField' }
                 | { __typename?: 'DateTimeField' }
                 | { __typename?: 'DropdownField' }
                 | { __typename?: 'EmailField' }
                 | { __typename?: 'FieldsSelectorField' }
                 | { __typename?: 'FileUploaderField' }
                 | { __typename?: 'FloatField' }
                 | { __typename?: 'GeoLocationField' }
                 | { __typename?: 'GeoShapeField' }
                 | { __typename?: 'IntegerField' }
                 | { __typename?: 'LongTextField' }
                 | { __typename?: 'MultiSelectField' }
                 | {
                      __typename?: 'PhoneNumberField'
                      fieldId: string
                      name: string
                   }
                 | { __typename?: 'PlainTextField' }
                 | { __typename?: 'RadioGroupField' }
                 | { __typename?: 'RelationField' }
                 | { __typename?: 'ShortTextField' }
                 | { __typename?: 'TimeField' }
                 | { __typename?: 'URLField' }
              >
           }>
        }
      | {
           __typename?: 'SalesTemplatesAccessDenied'
           message?: string | null
           salesTemplateIds: Array<string>
        }
      | {
           __typename?: 'SalesTemplatesNotFound'
           message?: string | null
           salesTemplateIds: Array<string>
        }
}

export const GetFieldsWithSystemFieldEnumDocument = gql`
   query getFieldsWithSystemFieldEnum($params: SearchFieldsParams!) {
      searchFields(params: $params) {
         ... on SalesTemplateFieldsResult {
            salesTemplateFields {
               fields {
                  ... on PhoneNumberField {
                     fieldId
                     name
                  }
               }
               salesTemplateId
            }
            totalCount
         }
         ... on InvalidLimit {
            message
         }
         ... on InvalidOffset {
            message
         }
         ... on PaginationLimitExceeded {
            message
         }
         ... on PipelineNotFound {
            message
            pipelineId
         }
         ... on PipelineAccessDenied {
            message
            pipelineId
            name
         }
         ... on SalesTemplatesNotFound {
            message
            salesTemplateIds
         }
         ... on SalesTemplatesAccessDenied {
            message
            salesTemplateIds
         }
      }
   }
`
export type GetFieldsWithSystemFieldEnumQueryResult = Apollo.QueryResult<
   GetFieldsWithSystemFieldEnumQuery,
   GetFieldsWithSystemFieldEnumQueryVariables
>
